import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router' // 如果你用 Vue Router

// 创建 axios 实例
const instance = axios.create({
  baseURL: 'https://shwlkj.xcsmx.com/back/',
  // baseURL: 'http://localhost:8080/back/',
  // baseURL: '',
  timeout: 120000
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 如果是后端自己封装的 code === 200
    if (response.data.code === 200) {
      return response.data
    } else {
      Message.error(response.data.msg || '请求失败')
      return Promise.reject(new Error(response.data.msg || '请求失败'))
    }
  },
  error => {
    // 如果是 HTTP 层面的错误
    if (error.response) {
      if (error.response.status === 401) {
        Message.error('登录状态已失效，请重新登录')

        // 清理本地 token
        localStorage.removeItem('token')

        // 跳转到登录页
        // 如果你用了 Vue Router
        router.push({ path: '/login' })
        // 或者简单粗暴
        // window.location.href = '/login'
      } else {
        Message.error(error.response.data?.message || '服务器错误，请稍后重试')
      }
    } else {
      Message.error('网络错误，请稍后重试')
    }

    return Promise.reject(error)
  }
)

export default instance
